export const SESSION_LENGTH_MINUTES = 90;
